export default __webpack_public_path__ + "/dist/images/profile-icon.2a4f1ea88b01fbe094360b4c977ab6da.svg";